import $ from "jquery"
import toastr from "toastr"

// Shared field-visibility toggle logic
// Usage:
// 1) Prefer setting data-profile-attribute-key on .profile-form
// 2) Backward compatible: initFieldToggles('sender_profile_attributes')

function fieldNameFor(profileAttributeKey) {
  return 'user[' + profileAttributeKey + '][hidden_fields][]';
}

function hiddenFieldsFromForm(form) {
  var hiddenFields = [];
  $('.field-visibility-toggle', form).each(function() {
    if (!this.checked) hiddenFields.push(this.dataset.field);
  });
  return hiddenFields;
}

function syncHiddenFieldsInputs(form, profileAttributeKey) {
  if (!profileAttributeKey) return;

  var fieldName = fieldNameFor(profileAttributeKey);
  var hiddenFields = hiddenFieldsFromForm(form);
  $('input[name="' + fieldName + '"]', form).remove();

  if (!hiddenFields.length) {
    $('<input>').attr({ type: 'hidden', name: fieldName, value: '' }).appendTo(form);
    return;
  }

  hiddenFields.forEach(function(field) {
    $('<input>').attr({ type: 'hidden', name: fieldName, value: field }).appendTo(form);
  });
}

function resolveProfileId(form, profileAttributeKey) {
  if (form.dataset.profileId) return form.dataset.profileId;
  return $('input[name="user[' + profileAttributeKey + '][id]"]', form).val();
}

function autosaveHiddenFields(form) {
  if (!form || form.dataset.autosaveHiddenFields !== 'true') return null;

  var profileAttributeKey = form.dataset.profileAttributeKey;
  if (!profileAttributeKey) return null;

  var profileId = resolveProfileId(form, profileAttributeKey);
  if (!profileId) return null;

  syncHiddenFieldsInputs(form, profileAttributeKey);

  var hiddenFields = hiddenFieldsFromForm(form);
  var payload = { user: {} };
  payload.user[profileAttributeKey] = {
    id: profileId,
    // Keep the key present even when empty so backend can clear hidden_fields.
    hidden_fields: hiddenFields.length ? hiddenFields : ['']
  };

  // If user toggles rapidly, cancel the previous request and keep the latest state.
  if (form._hiddenFieldsRequest && form._hiddenFieldsRequest.readyState !== 4) {
    form._hiddenFieldsRequest.abort();
  }

  form._hiddenFieldsRequest = $.ajax({
    url: form.action,
    type: 'PATCH',
    data: payload,
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
  });

  return form._hiddenFieldsRequest;
}

function showProfileFieldError($anchor, message) {
  var $existing = $anchor.next('.profile-field-error');
  if ($existing.length) {
    $existing.text(message || 'This field is required.');
  } else {
    $('<div class="profile-field-error text-danger small mt-1"></div>')
      .text(message || 'This field is required.')
      .insertAfter($anchor);
  }
}

function clearProfileFieldError($field) {
  $field.removeClass('is-invalid profile-select2-invalid');
  var $container = $field.next('.select2-container');
  if ($container.length) {
    $container.removeClass('select2-is-invalid');
    $container.next('.profile-field-error').remove();
  } else {
    $field.next('.profile-field-error').remove();
  }
}

function validateProfileRequiredFields(form) {
  var valid = true;
  var $firstError = null;

  $(form).find('[required]').each(function() {
    var $field = $(this);
    var value = ($field.val() || '');

    if (!value || (Array.isArray(value) && !value.length)) {
      valid = false;
      var $container = $field.next('.select2-container');

      if ($container.length) {
        $container.addClass('select2-is-invalid');
        showProfileFieldError($container);
        if (!$firstError) $firstError = $container;
      } else {
        $field.addClass('is-invalid');
        showProfileFieldError($field);
        if (!$firstError) $firstError = $field;
      }
    } else {
      var minlength = parseInt($field.attr('minlength'), 10);
      if (!isNaN(minlength) && value.length < minlength) {
        valid = false;
        $field.addClass('is-invalid');
        showProfileFieldError($field, 'Must be at least ' + minlength + ' characters.');
        if (!$firstError) $firstError = $field;
      }
    }
  });

  if ($firstError) {
    $('html, body').animate({ scrollTop: $firstError.offset().top - 150 }, 300);
  }

  return valid;
}

function bindFieldToggleEvents() {
  // Use delegated listener with namespace so re-running this (Turbolinks) doesn't stack
  $(document)
    .off('change.fieldToggle')
    .on('change.fieldToggle', '.field-visibility-toggle', function() {
      var toggle = this;
      var previousValue = !toggle.checked;
      var form = toggle.closest('form.profile-form');

      if (!form) return;

      var request = autosaveHiddenFields(form);
      if (request) {
        request
          .done(function() {
            toastr.remove();
            if (toggle.checked) {
              toastr.success('Field is now visible to public');
            } else {
              toastr.info('Field is now hidden from public');
            }
          })
          .fail(function(xhr, status) {
            if (status === 'abort') return;
            toggle.checked = previousValue;
            syncHiddenFieldsInputs(form, form.dataset.profileAttributeKey);
            toastr.remove();
            toastr.error('Could not save toggle. Please try again.');
          });
        return;
      }

      // Fallback behavior when autosave is not enabled for this form.
      toastr.remove();
      if (toggle.checked) {
        toastr.success('Field is now visible to public');
      } else {
        toastr.info('Field is now hidden from public');
      }
    });

  // Clear inline error when user fixes a required field
  $(document)
    .off('input.fieldToggle change.fieldToggle', '.profile-form [required]')
    .on('input.fieldToggle change.fieldToggle', '.profile-form [required]', function() {
      var $field = $(this);
      if ($field.val()) {
        clearProfileFieldError($field);
      }
    });

  // Build hidden_fields array for the submitted profile form
  $(document)
    .off('submit.fieldToggle', '.profile-form')
    .on('submit.fieldToggle', '.profile-form', function(event) {
      var form = this;

      if (!validateProfileRequiredFields(form)) {
        event.preventDefault();
        if (typeof window.hidePageLoader === 'function') window.hidePageLoader();
        return false;
      }

      var profileAttributeKey = form.dataset.profileAttributeKey;
      if (!profileAttributeKey) return;
      syncHiddenFieldsInputs(form, profileAttributeKey);
    });
}

window.initFieldToggles = function(profileAttributeKey) {
  var $forms = $('.profile-form');
  if (!$forms.length) return;

  $forms.attr('novalidate', true);

  if (profileAttributeKey) {
    $forms.each(function() {
      this.dataset.profileAttributeKey = profileAttributeKey;
    });
  }

  bindFieldToggleEvents();
};

$(document).on('turbolinks:load', function() {
  $('.profile-form').attr('novalidate', true);
  bindFieldToggleEvents();
});
